import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchedData } from '../../util/utils';

export const loadUnpDepartment = createAsyncThunk(
  'unpDepartment/getUnpDepartment',
  async (id) => await fetchedData('department/getDepartment', 'POST', { id })
);
